import { IShardClusterRequestParams, IShardClusterListItem, ShardClusterSortField } from "../../api/entities/shard-cluster";
import { IDeleteBlockedConfirmationDataV2 } from '../../components/shard-clusters/dialogs/delete-blocked-confirmation/delete-blocked-confirmation';
import { commonActions, handleApi } from './common';
import { DialogActions } from './dialog';
import { EntityActions, EntityThunkActions } from './entity';
import { IShardRepositoryCredentialsConfirmationData } from "../../api/entities/shard-repository";
import { shardClusterService } from "../../api/services/shard-cluster-service";

export const SHARD_CLUSTER_ENTITY_NAME = "shardCluster";
export const DELETE_CONFIRMATION_DIALOG_NAME = "deleteConfirmation";
export const DELETE_BLOCKED_CONFIRMATION_DIALOG_NAME = "deleteBlockedConfirmation";
export const CREDENTIALS_INFO = "credentialsConfirmation";

class ShardClusterActions {
  readonly entity;
  readonly deleteConfirmation;
  readonly deleteBlockedConfirmation;
  readonly replaceStorageConfirmation;
  readonly credentialsInfo;

  constructor() {
    let entityName = SHARD_CLUSTER_ENTITY_NAME;
    this.entity = new EntityActions<IShardClusterListItem, IShardClusterRequestParams>(entityName);
    this.deleteConfirmation = new DialogActions<IShardClusterListItem>(entityName, DELETE_CONFIRMATION_DIALOG_NAME);
    this.deleteBlockedConfirmation = new DialogActions<IDeleteBlockedConfirmationDataV2>(entityName, DELETE_BLOCKED_CONFIRMATION_DIALOG_NAME);
    this.credentialsInfo = new DialogActions<IShardRepositoryCredentialsConfirmationData>(entityName, CREDENTIALS_INFO);
  }
}

export const storagePoolActions = new ShardClusterActions();

class ShardClusterThunkActions {
  readonly entity;

  constructor() {
    this.entity = new EntityThunkActions<IShardClusterListItem, ShardClusterSortField, IShardClusterRequestParams>(
        SHARD_CLUSTER_ENTITY_NAME,
        shardClusterService
      );
  }

  delete(storagePoolId: string) {
    return (dispatch) => {
      return handleApi(shardClusterService
        .delete(storagePoolId)
        .then(() => {
          dispatch(
            commonActions.showSnackBar(
              true,
              `Shard Cluster is successfully deleted.`
            )
          );
          dispatch(this.entity.fetchPage());
        }), true);
    };
  }
}
export const shardClusterThunkActions = new ShardClusterThunkActions();

